module.exports = __webpack_public_path__ + "static/media/webview-img1.138ebffc.png";